import { withViewModel } from '@hooks/useViewModel';
import CreateOrEditListDialog from './CreateOrEditListDialog';
import useCreateListDialog from './useCreateListDialog';

const CreateOrEditListDialogContainer = withViewModel(CreateOrEditListDialog, useCreateListDialog);

export default CreateOrEditListDialogContainer;
